import { render, staticRenderFns } from "./upshebei.vue?vue&type=template&id=750fe1b2&scoped=true&"
import script from "./upshebei.vue?vue&type=script&lang=js&"
export * from "./upshebei.vue?vue&type=script&lang=js&"
import style0 from "./upshebei.vue?vue&type=style&index=0&id=750fe1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750fe1b2",
  null
  
)

export default component.exports